import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Inject
} from '@angular/core';
import {
  FullScreenWindow,
  CloseWindow,
  MinimizeWindow
} from '../window.actions';
import {
  getWindowIcon,
  getWindowTitle
} from '../window.selectors';
import { WINDOW_CONTAINER_CONTEXT } from '../tokens';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  selector:        'dx-window-tool-bar',
  templateUrl:     './window-tool-bar.component.html',
  styleUrls:       [ './window-tool-bar.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WindowToolBarComponent implements OnInit {

  public windowId: string;

  public icon$: Observable<string>;
  public title$: Observable<string>;

  constructor(@Inject(WINDOW_CONTAINER_CONTEXT) context: any, public store$: Store<any>) {
    this.windowId = context.id;
  }

  ngOnInit() {
    this.icon$  = this.store$.select(getWindowIcon(this.windowId));
    this.title$ = this.store$.select(getWindowTitle(this.windowId));
  }

  fullScreen() {
    this.store$.dispatch(new FullScreenWindow(this.windowId, 'WindowToolBarComponent::fullScreen'));
  }

  close() {
    this.store$.dispatch(new CloseWindow(this.windowId, 'WindowToolBarComponent::close'));
  }

  minimize() {
    this.store$.dispatch(new MinimizeWindow(this.windowId, 'WindowToolBarComponent::minimize'));
  }

}
